import React, { useState, useEffect } from 'react';
import { calculateSolarEnergyProduction } from './calculations';
import Plot from 'react-plotly.js';
import html2canvas from 'html2canvas'; // Import html2canvas library
import { FaDollarSign, FaBolt, FaSun, FaWrench, FaCog, FaRegLightbulb, FaChartLine,FaMoneyBillWave,FaSave } from 'react-icons/fa'; // Import Icons



const FinancialAnalysisComponent = ({
  financialanalysisdata,
  onImageUpdate,
  financialanalysisresults,
  setElectricityBillWithoutSolarPerYearX,
  setElectricityBillWithoutSolarPerYearY,
  setTotalSolarInvestmentPerYearX,
  setTotalSolarInvestmentPerYearY,
}) => {
  const [monthlyBill, setMonthlyBill] = useState("300");
  const [showModal, setShowModal] = useState(false);
  const [energyCostPerKwh, setEnergyCostPerKwh] = useState("2.00");
  const [solarInsentives, setSolarInsentives] = useState("6995.00");
  const [installationCostPerWatt, setInstallationCostPerWatt] =
    useState("24.00");
  const [dcToAcConversionFactor, setDcToAcConversionFactor] = useState("85");
  const [
    panelEfficiencyDepreciationFactor,
    setPanelEfficiencyDepreciationFactor,
  ] = useState("0.5");
  const [panelLifetime, setPanelLifetime] = useState("20");
  const [energyCostPerYear, setEnergyCostPerYear] = useState("2.2");
  const [discountRatePerYear, setDiscountRatePerYear] = useState("4");
  const [solarAnalysisResult, setSolarAnalysisResult] = useState(null);
  const [selectedYear, setSelectedYear] = useState(1);

  function findCrossoverYear(data1, data2) {
    for (let i = 1; i < data1.length - 1; i++) {
      if (
        (data1[i] <= data2[i] && data1[i + 1] > data2[i + 1]) ||
        (data1[i] >= data2[i] && data1[i + 1] < data2[i + 1])
      ) {
        // Crossover detected
        // Interpolate to find the exact crossover year
        const slope1 = (data1[i + 1] - data1[i]) / (i + 1 - i);
        const slope2 = (data2[i + 1] - data2[i]) / (i + 1 - i);
        const year = i + (data2[i] - data1[i]) / (slope1 - slope2);
        return Math.round(year);
      }
    }
    // No crossover found
    return null;
  }

  const takeScreenshot = () => {
    // Use html2canvas to capture the plot container
    html2canvas(document.getElementById("financial-analysis-plot")).then(
      (canvas) => {
        // Convert the canvas to a data URL
        const imageUrl = canvas.toDataURL("image/png");
        // Call the onImageUpdate function with the image URL
        onImageUpdate(imageUrl);
      }
    );
  };

  useEffect(() => {
    // Take a screenshot with a delay when the component mounts or when any dependency changes
    const timeoutId = setTimeout(() => {
      takeScreenshot();
    }, 500); // Adjust the delay time as needed (in milliseconds)

    return () => clearTimeout(timeoutId); // Clear the timeout on component unmount or dependency change
  }, [
    financialanalysisdata,
    solarAnalysisResult,
    monthlyBill,
    energyCostPerKwh,
    solarInsentives,
    installationCostPerWatt,
    dcToAcConversionFactor,
    panelEfficiencyDepreciationFactor,
    panelLifetime,
    energyCostPerYear,
    discountRatePerYear,
    selectedYear,
  ]);

  // Function to handle slider change
  const handleYearChange = (event) => {
    setSelectedYear(parseInt(event.target.value));
  };

  const handleSubmit = () => {
    // Perform any necessary action on form submission
    console.log("Financial Analysis Data:", financialanalysisdata);
  };

  useEffect(() => {
    const result = calculateSolarEnergyProduction(
      parseFloat(monthlyBill),
      parseFloat(energyCostPerKwh),
      parseFloat(solarInsentives),
      parseFloat(installationCostPerWatt),
      parseFloat(dcToAcConversionFactor),
      parseFloat(panelEfficiencyDepreciationFactor),
      parseFloat(panelLifetime),
      parseFloat(energyCostPerYear),
      parseFloat(discountRatePerYear),
      financialanalysisdata
    );
    setSolarAnalysisResult(result);
  }, [
    monthlyBill,
    energyCostPerKwh,
    solarInsentives,
    installationCostPerWatt,
    dcToAcConversionFactor,
    panelEfficiencyDepreciationFactor,
    panelLifetime,
    energyCostPerYear,
    discountRatePerYear,
    financialanalysisdata,
  ]);

  let crossoverYear = null;
  if (solarAnalysisResult) {
    crossoverYear = findCrossoverYear(
      solarAnalysisResult.electricityBillWithoutSolarPerYear,
      solarAnalysisResult.totalSolarInvestmentPerYear
    );
  }

    useEffect(() => {
        financialanalysisresults(solarAnalysisResult,crossoverYear,monthlyBill,energyCostPerKwh,solarInsentives,installationCostPerWatt,dcToAcConversionFactor,panelEfficiencyDepreciationFactor,panelLifetime,energyCostPerYear,discountRatePerYear)
    }, [solarAnalysisResult,crossoverYear,monthlyBill,energyCostPerKwh,solarInsentives,installationCostPerWatt,dcToAcConversionFactor,panelEfficiencyDepreciationFactor,panelLifetime,energyCostPerYear,discountRatePerYear]);





    return (
        <div>
        <div
        style={{
            position: 'absolute',
            top: '50%',
            left: '20px',
            transform: 'translateY(-50%)',
            width: '22vw',
            height: '95vh', // 9:16 aspect ratio
            maxHeight: '95vh',
            backgroundColor: '#fff',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
            borderRadius: '15px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            overflowY: 'auto',
            fontFamily: "'Poppins', sans-serif", // ✨ Modern font
            zIndex: 10
        }}>
   <div
    style={{
        padding: '20px',
        borderRadius: '12px',
        backgroundColor: '#fff',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        fontFamily: "'Poppins', sans-serif",
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
    }}
>
    {/* Title */}
    <h2 style={{ 
        fontSize: '18px', 
        fontWeight: '600', 
        color: '#333',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    }}>
        <FaChartLine size={20} color="#FF9800" />
        Financial Analysis
    </h2>

    {/* Input Fields with Custom Hover Tooltips */}
    {[
        { label: "Monthly Average Bill", value: monthlyBill, setter: setMonthlyBill, icon: <FaDollarSign color="#4CAF50" /> },
        { label: "Energy Cost per kWh", value: energyCostPerKwh, setter: setEnergyCostPerKwh, icon: <FaBolt color="#FF9800" /> },
        { label: "Solar Incentives", value: solarInsentives, setter: setSolarInsentives, icon: <FaSun color="#1E88E5" /> },
        { label: "Installation Cost per Watt", value: installationCostPerWatt, setter: setInstallationCostPerWatt, icon: <FaWrench color="#795548" /> },
        { label: "DC to AC Conversion Factor (%)", value: dcToAcConversionFactor, setter: setDcToAcConversionFactor, icon: <FaCog color="#607D8B" /> },
        { label: "Panel Efficiency Depreciation (%)", value: panelEfficiencyDepreciationFactor, setter: setPanelEfficiencyDepreciationFactor, icon: <FaRegLightbulb color="#FFC107" /> },
        { label: "Panel Lifetime (years)", value: panelLifetime, setter: setPanelLifetime, icon: <FaSun color="#03A9F4" /> },
        { label: "Energy Cost Increase per Year (%)", value: energyCostPerYear, setter: setEnergyCostPerYear, icon: <FaBolt color="#FF5722" /> },
        { label: "Discount Rate per Year (%)", value: discountRatePerYear, setter: setDiscountRatePerYear, icon: <FaDollarSign color="#673AB7" /> }
    ].map((field, index) => (
        <div key={index} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '10px', 
            position: 'relative' 
        }}
            onMouseEnter={(e) => {
                const tooltip = e.currentTarget.querySelector('.tooltip');
                tooltip.style.opacity = "1";
                tooltip.style.transform = "translateY(-10px)";
            }}
            onMouseLeave={(e) => {
                const tooltip = e.currentTarget.querySelector('.tooltip');
                tooltip.style.opacity = "0";
                tooltip.style.transform = "translateY(0px)";
            }}
        >
            {field.icon}
            <div className="tooltip"
                style={{
                    position: 'absolute',
                    bottom: '40px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#333',
                    color: 'white',
                    fontSize: '12px',
                    padding: '6px 10px',
                    borderRadius: '6px',
                    whiteSpace: 'nowrap',
                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
                    opacity: '0',
                    transition: 'opacity 0.2s ease, transform 0.2s ease',
                    pointerEvents: 'none'
                }}
            >
                {field.label}
            </div>
            <input
                type="number"
                value={field.value}
                onChange={(e) => field.setter(e.target.value)}
                style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                    fontSize: '14px',
                    textAlign: 'center',
                    transition: '0.1s ease',
                    outline: 'none'
                }}
            />
        </div>
    ))}

    {/* Submit Button */}
    <button 
        onClick={handleSubmit}
        style={{
            backgroundColor: '#FF9800',
            color: 'white',
            border: 'none',
            padding: '10px 14px',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: '0.3s ease',
            fontSize: '14px',
            fontWeight: '500',
            letterSpacing: '0.3px',
            marginTop: '10px'
        }}
        onMouseOver={(e) => e.target.style.opacity = '0.85'}
        onMouseOut={(e) => e.target.style.opacity = '1'}
    >
        Submit
    </button>
</div>

        <div
    style={{
        width: '90%',
        margin: '20px auto',
        backgroundColor: '#fff',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        borderRadius: '12px',
        padding: '15px',
        fontFamily: "'Poppins', sans-serif",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
    }}
>
    <h3 style={{ 
        fontSize: '18px', 
        fontWeight: '600', 
        color: '#333',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    }}>
        <FaChartLine size={20} color="#FF9800" />
        Output Summary (20 Years)
    </h3>

    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px' }}>
        {[
            { label: "Total Energy", value: `${solarAnalysisResult?.totalEnergyProducedIn20Years.toFixed(2)} kWh`, icon: <FaBolt color="#FF5722" size={18} /> },
            { label: "Total Bill Without Solar", value: `$${solarAnalysisResult?.totalBillWithoutSolar.toFixed(2)}`, icon: <FaMoneyBillWave color="#4CAF50" size={18} /> },
            { label: "Total Solar Investment", value: `$${solarAnalysisResult?.totalSolarInvestment.toFixed(2)}`, icon: <FaDollarSign color="#1E88E5" size={18} /> },
            { label: "Total Savings", value: `$${solarAnalysisResult?.totalSavings.toFixed(2)}`, icon: <FaSave color="#673AB7" size={18} /> }
        ].map((item, index) => (
            <div key={index} style={{
                backgroundColor: '#F9F9F9',
                padding: '10px 15px',
                borderRadius: '8px',
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                {item.icon}
                <span style={{ fontWeight: '500', color: '#333' }}>{item.label}: </span>
                <strong style={{ color: '#FF9800' }}>{item.value}</strong>
            </div>
        ))}
    </div>
</div>

{/* ✅ Financial Analysis Plot Section */}
<div id="financial-analysis-plot" 
    style={{
        width: '90%',
        margin: '20px auto',
        backgroundColor: '#fff',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        borderRadius: '12px',
        padding: '15px',
        fontFamily: "'Poppins', sans-serif",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
    }}
>
    <h3 style={{ 
        fontSize: '15px', 
        fontWeight: '600', 
        color: '#333',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    }}>
        <FaChartLine size={20} color="#1E88E5" />
        Electricity Bill vs Solar Investment
    </h3>

    </div>
    

    <div>

    <Plot
    data={[
        {
            x: Array.from({ length: solarAnalysisResult?.electricityBillWithoutSolarPerYear?.length }, (_, i) => i),
            y: solarAnalysisResult?.electricityBillWithoutSolarPerYear,
            type: 'scatter',
            mode: 'lines+markers',
            name: 'Bill Without Solar',
            line: { color: '#FF5722', width: 2 },
            marker: { color: '#FF5722', size: 6 }
        },
        {
            x: Array.from({ length: solarAnalysisResult?.totalSolarInvestmentPerYear?.length }, (_, i) => i),
            y: solarAnalysisResult?.totalSolarInvestmentPerYear,
            type: 'scatter',
            mode: 'lines+markers',
            name: 'Solar Investment',
            line: { color: '#4CAF50', width: 2 },
            marker: { color: '#4CAF50', size: 6 }
        }
    ]}
    layout={{
        autosize: true,
        responsive: true,
        xaxis: {
            title: { text: 'Years', font: { size: 12, color: '#555' } },
            tickangle: -45,
            gridcolor: 'rgba(200,200,200,0.3)',
            zerolinecolor: '#ccc'
        },
        yaxis: {
            title: { text: 'Cost ($)', font: { size: 12, color: '#555' } },
            gridcolor: 'rgba(200,200,200,0.3)',
            zerolinecolor: '#ccc'
        },
        margin: { l: 40, r: 20, t: 30, b: 50 },
        showlegend: true,
        legend: {
            x: 0,
            y: 1.1,
            orientation: "h",
            font: { size: 12 }
        },
        plot_bgcolor: "#F9F9F9",
        paper_bgcolor: "rgba(0,0,0,0)",
        font: { family: 'Poppins, sans-serif', size: 12 }
    }}
    useResizeHandler={true}
    style={{ width: "100%", height: "100%", maxHeight: "400px" }}
/>
</div>
            <div>
                {/* Display Output Fields
                <h3>Output for each year</h3>
                <p>Total Energy Produced in {selectedYear} Year: {solarAnalysisResult?.acEnergyPerYear[selectedYear].toFixed(3)} kWh</p>
                <p>Annual Energy Consumption: {solarAnalysisResult?.averageYearlyConsumption.toFixed(3)} kWh</p>
                <p>Cost With Solar: {selectedYear === 1 ? solarAnalysisResult?.electricityBillWithSolarPerYear[selectedYear] + solarAnalysisResult?.totalPanelInstallationCost  - parseFloat(solarInsentives) : solarAnalysisResult?.electricityBillWithSolarPerYear[selectedYear]} $</p>
                <p>Cost Without Solar: {solarAnalysisResult?.electricityBillWithoutSolarPerYear_eachyear[selectedYear]} $</p> */}

                {/* Slider for selecting year */}
                {/* <input
                    type="range"
                    min={1}
                    max={panelLifetime}
                    value={selectedYear}
                    onChange={handleYearChange}
                /> */}

                {/* Bar chart for comparing costs */}
                {/* <h3>Cost Comparison for Year {selectedYear}</h3>
                <Plot
                    data={[
                        {
                            x: [selectedYear === 1 ?'With Solar Considering installation cost and solar insentives':'With Solar', 'Without Solar'],
                            y: [
                                selectedYear === 1 ? solarAnalysisResult?.electricityBillWithSolarPerYear[selectedYear] + solarAnalysisResult?.totalPanelInstallationCost  - parseFloat(solarInsentives) : solarAnalysisResult?.electricityBillWithSolarPerYear[selectedYear],
                                solarAnalysisResult?.electricityBillWithoutSolarPerYear_eachyear[selectedYear]
                            ],
                            type: 'bar',
                            marker: {
                                color: ['#1f77b4', '#ff7f0e']
                            }
                        }
                    ]}
                    layout={{ width: 600, height: 400, title: `Cost Comparison for Year ${selectedYear}` }}
                /> */}

                {/* Bar chart for comparing energy produced
                <h3>Energy Production Comparison for Year {selectedYear}</h3>
                <Plot
                    data={[
                        {
                            x: ['Energy Produced By Solar', 'Energy Consumption'],
                            y: [solarAnalysisResult?.acEnergyPerYear[selectedYear], solarAnalysisResult?.averageYearlyConsumption],
                            type: 'bar',
                            marker: { color: ['#1f77b4', '#ff7f0e'] }
                        }
                    ]}
                    layout={{ width: 600, height: 400, title: `Energy Production Comparison for Year ${selectedYear}` }}
                /> */}
            </div>
        </div>
        </div>
        
    );
};

export default FinancialAnalysisComponent;
